<template lang="pug">
    .request-driver
        v-btn.px-0(
            color="primary"
            :disabled="!model.canYouCreateProviderJob"
            @click="setDialog(true)" text x-small)
            span.text-subtitle-2 {{$t('labels.new_driver')}}
            v-icon(dense) chevron_right
        modal-dialog.request-driver-modal(
            v-model="dialog"
            :title="$t('labels.new_driver')"
            :show-overlay="loading"
            :ok-text="$t('actions.request')"
            :ok-loading="loading"
            @cancel="onCancel"
            @ok="createRequestNewDelivery"
            cancel-button)
            template
                date-picker-input(v-model="pickupTime" label="orders.pickup_date_now" :min="$date().format()")
                label.text-h6.text-dense {{$t('labels.delivery_method')}}
                v-radio-group.mt-0(v-model="deliveryMethod" dense)
                    v-radio(
                        v-for="(method,index) in deliveryMethods"
                        :key="`DeliveryRule-${index}`"
                        :value="method.value"
                        :label="method.label")
                v-checkbox(v-model="noAutoCancel" :false-value="false" :label="$t('labels.turn_off_auto_cancel')")


</template>

<script>
import ModalDialog from '@/components/dialog/ModalDialog'
import RestApiCollection from '@/api/RestApiCollection'
import ApiClientType from '@/api/RestApiType'
import DatePickerInput from '@/components/form/Inputs/DatePickerInput'
import debounce from 'debounce-promise'

export default {
    components: {
        DatePickerInput,
        ModalDialog,
    },
    props: {
        model: {
            type: Object,
            default: () => {},
        },
        identifier: null,
    },
    data() {
        return {
            dialog: false,
            loading: false,
            noAutoCancel: false,
            deliveryMethod: null,
            pickupTime: null,
        }
    },
    computed: {
        deliveryMethods() {
            let deliveryRules =
                this.model?.deliveryMethodsFromDeliveryRule || []
            let allLabel = this.$t(`enums.delivery_methods.all`)
            let methods = []
            if (deliveryRules.length > 1)
                methods = [
                    {
                        label: '',
                        value: deliveryRules,
                    },
                ]
            deliveryRules?.forEach((rule, index) => {
                methods.push({
                    label: this.$t(`enums.delivery_methods.${rule}`),
                    value: [rule],
                })

                if (deliveryRules.length > 1)
                    allLabel = allLabel.concat(
                        `${index === 0 ? ' (' : ', '}${this.$t(
                            `enums.delivery_methods.${rule}`
                        )}${index === deliveryRules.length - 1 ? ')' : ''}`
                    )
            })

            if (deliveryRules.length > 1) methods[0].label = allLabel
            return methods
        },
    },

    methods: {
        createProviderJob(method) {
            return RestApiCollection.get(
                ApiClientType.DELIVERIES
            ).createAndQueueDeliveryProviderJob(
                {
                    method: method,
                    disableAutoCancel: this.noAutoCancel,
                },
                this.model.id
            )
        },
        setDialog(value) {
            this.dialog = value
            if (this.dialog) {
                this.deliveryMethod = this.deliveryMethods?.[0]?.value
                this.noAutoCancel = false
            }
        },
        onApprove() {
            this.setDialog(false)
            this.$emit('onApprove')
        },
        onCancel() {
            this.setDialog(false)
            this.$emit('onCancel')
        },
        createRequestNewDelivery() {
            this.loading = true

            RestApiCollection.get(ApiClientType.DELIVERIES)
                .updateDeliveryJob({
                    ...this.model,
                    ...{
                        pickupTime:
                            this.pickupTime ||
                            this.$date().add(1, 'm').format(),
                    },
                })
                .then(() => {
                    const debounced = debounce(this.createProviderJob, 1000, {
                        leading: true,
                    })
                    Promise.all(
                        this.deliveryMethod.map((method) => {
                            return debounced(method)
                        })
                    )
                        .then(() => {
                            RestApiCollection.get(ApiClientType.DELIVERIES)
                                .getProviderJob(this.identifier)
                                .then(() => {
                                    this.onApprove()
                                })
                                .finally(() => {
                                    this.loading = false
                                })
                        })
                        .catch(() => {
                            this.loading = false
                        })
                })
                .catch(() => {
                    this.loading = false
                })
        },
    },
}
</script>
